import React, { createContext, ReactNode, useContext, useState } from 'react';
import { OrderKind } from 'consts/enums/order';
import usePropertyOwnership, {
  PropertyOwnershipType,
} from '../../../../../hooks/requests/properties/usePropertyOwnership';
import { DEBT_TICKER } from '../../../../../pages/lend/utils';

type DebtContextType = {
  orderKind: OrderKind;
  setOrderKind: (kind: OrderKind) => void;
  propertyOwnership?: PropertyOwnershipType;
};

const DebtContext = createContext<DebtContextType>({} as DebtContextType);

type Props = {
  children: ReactNode;
};

export const DebtProvider = ({ children }: Props) => {
  const [orderKind, setOrderKind] = useState<OrderKind>(OrderKind.BUY);
  const { propertyOwnership } = usePropertyOwnership(DEBT_TICKER);

  return (
    <DebtContext.Provider
      value={{
        orderKind,
        setOrderKind,
        propertyOwnership,
      }}
    >
      {children}
    </DebtContext.Provider>
  );
};

export const useDebt = () => {
  return useContext(DebtContext);
};
